import {clsx} from 'external/clsx'
import {useMemo, useState, Form} from 'external/react'
import Icon, {IconName} from 'external/fortawesome'

export default function FormTextfield (props) {
    const {fieldName, error, type= 'text', defaultValue, value, placeholder, onChange, maxLength = 255, className, children, submitted, controlProps} = props
    const errorType = useMemo(() => Array.isArray(error) ? 'multiple' : (error && 'simple'), [error])
    const errorClass = useMemo(() => errorType === 'simple' && submitted ? 'visible' : 'd-none', [errorType, submitted])
	return (
        <>
        <div className={clsx('form-group', 'mt-2', 'mb-1', className)}>
            <Form.Control type={type} defaultValue={defaultValue} value={value} placeholder={placeholder} name={fieldName} onChange={onChange} maxLength={maxLength} {...controlProps} />
              {children}
        </div>
        {errorType !== 'multiple' && (<small className={clsx('text-danger', errorClass)}>{error || '&nbsp;'}</small>)}
        {submitted && errorType === 'multiple' && error.length > 0 && (
            <div>
                <ul className='text-danger' style={{ fontSize: '12px', margin: 'auto' }}>
                    {error.map((text, key) => (<li key={key}>{text}</li>))}
                </ul>
            </div>
        )}
        </>
	)
}

						

export function PasswordField (props) {
    const [clear, setClear] = useState(false)
    const [type, icon] = useMemo(() => clear ? ['text', 'faEyeSlash' as IconName] : ['password', 'faEye' as IconName], [clear])
    return (
        <FormTextfield {...props} type={type} className={clsx('input-icon-wrapper', props.className)}>
            <div className='icon-container' onClick={() => setClear(!clear)}>
                <Icon name={icon}/>
            </div>
        </FormTextfield>
    )
}